import { AppLogo } from './AppLogo';

export const AppHeader = () => {
  return (
    <div className="flex flex-col gap-4 border-b border-silver px-40 py-16">
      <AppLogo height={32} width={116} />

      <div className="pl-46 text-sm text-deep-blue">Pulse for Meetings</div>
    </div>
  );
};
